import { QueryClient } from '@tanstack/react-query';
import { createRouter } from '@tanstack/react-router';
import { routeTree } from '@/app/routeTree.gen';
import { API_CONSTANTS } from '@/shared/constants';
import { LoadingSpinner } from '@/shared/ui/loading-spinner';

// Create query client with centralized constants
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: API_CONSTANTS.QUERY_RETRY_COUNT,
      refetchOnWindowFocus: false,
      staleTime: API_CONSTANTS.STALE_TIME_MS,
      gcTime: API_CONSTANTS.GC_TIME_MS,
      refetchOnMount: true,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: API_CONSTANTS.MUTATION_RETRY_COUNT,
    },
  },
});

// Create router instance
export const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
  // 프리페칭 전략: 'intent' (호버/포커스 시), 'viewport' (뷰포트 진입 시), 'render' (렌더링 시)
  defaultPreload: 'intent',
  // 프리로드된 데이터의 stale 시간 (0 = 항상 최신 데이터 프리페치)
  defaultPreloadStaleTime: 0,
  // 프리로드 딜레이 (ms) - 호버 후 50ms 대기하여 불필요한 프리페치 방지
  defaultPreloadDelay: 50,
  // 기본 로딩 컴포넌트
  defaultPendingComponent: () => <LoadingSpinner size="lg" text="페이지 로딩 중..." />,
  // 기본 에러 바운더리 옵션
  defaultErrorComponent: ({ error }) => (
    <div className="flex flex-col items-center justify-center min-h-screen gap-4">
      <h1 className="text-2xl font-bold text-destructive">페이지 로드 실패</h1>
      <p className="text-muted-foreground">{error.message}</p>
    </div>
  ),
});

// Register router for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
